import { createContext } from 'react';

interface EditListModalContextProps {
  isOpen: boolean; // Is "edit list" modal open or closed
  onToggle: () => void; // Toggles isOpen
  setOnUpdated?: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditListModalContext = createContext<EditListModalContextProps>({
  isOpen: false,
  onToggle: () => {},
  setOnUpdated: () => {},
});

export default EditListModalContext;
